import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { DateTime } from "luxon";
import { Observable, distinctUntilChanged, map, timer } from "rxjs";

@Component({
  selector: "app-last-updated",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./last-updated.component.html",
  styleUrl: "./last-updated.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LastUpdatedComponent implements OnInit {
  @Input() refreshing: boolean = false;
  @Input() lastUpdated?: DateTime | null;
  // @Input() lastUpdatedText: string = "";
  lastUpdatedText$?: Observable<string>;

  @Output() refresh = new EventEmitter();

  ngOnInit(): void {
    this.lastUpdatedText$ = timer(0, 1000).pipe(
      map(() => {
        if (this.lastUpdated) {
          // All time stamps are set to UTC time zone to keep them from changing when the device
          // changes time zone. Now needs to be UTC as well to keep the dates from being different
          // late in the day.
          const now = DateTime.now().toUTC();
          const dataAge = this.lastUpdated.diff(now, [
            "days",
            "hours",
            "minutes",
          ]);
          const minutes = Math.trunc(Math.abs(dataAge.minutes));
          const hours = Math.trunc(Math.abs(dataAge.hours));
          const days = Math.trunc(Math.abs(dataAge.days));

          if (days === 0 && hours === 0 && minutes === 0) {
            return "Updated just now";
          } else if (days > 0) {
            return `Updated ${days} day${days < 2 ? "" : "s"} ago`;
          } else if (hours > 0) {
            return `Updated ${hours} hour${hours < 2 ? "" : "s"} ago`;
          } else {
            return `Updated ${minutes} min ago`;
          }
        }
        return "";
      }),
      distinctUntilChanged(),
    );
  }

  onRefresh() {
    this.refresh.emit();
  }
}
